export default __webpack_public_path__ + "static/media/Banner - Artisan Pro - Red.a13900d6.jpg";